import HorizontalBarChart from '@bumble/app/components/HorizontalBarChart';
import { useEffect, useState } from 'react';
// import DataTableGrid from '@bumble/app/components/DataTableGrid';
import { Loading } from '@bumble/app/components/Loading';
import NoData from '@bumble/app/components/NoData';
import TimeRange from '@bumble/app/components/TimeRange';
import { TIME_BUTTONS } from '@bumble/app/constants';
import { useApi } from '@bumble/app/hooks/use-api';
import { Box, Card, CardContent } from '@mui/material';
// import { GridColDef } from '@mui/x-data-grid';
import { useQuery } from '@tanstack/react-query';
import { DateTime, DurationLike } from 'luxon';
import { toast } from 'react-toastify';

// const columns: GridColDef[] = [
//   {
//     field: 'epid',
//     headerName: 'Endpoint ID',
//     disableColumnMenu: true,
//   },
//   {
//     field: 'total_bytes',
//     headerName: 'Total Bytes',
//     disableColumnMenu: true,
//   },
//   {
//     field: 'tx_bytes',
//     headerName: 'TX Bytes',
//     disableColumnMenu: true,
//   },
//   {
//     field: 'rx_bytes',
//     headerName: 'RX Bytes',
//     disableColumnMenu: true,
//     headerAlign: 'right',
//     align: 'right',
//   },
// ];

// const columnVisible = {
//   epid: true,
//   total_bytes: true,
//   tx_bytes: true,
//   rx_bytes: true,
// };

export const AppServicesTabTalker = ({ id }: { id: string }) => {
  const api = useApi();
  const [timeRange, setTimeRange] = useState<DurationLike>(TIME_BUTTONS[0].value);
  const { isLoading, data, refetch, isRefetching } = useQuery(
    ['appServiceTopTalker'],
    api.getTopTalkerEpApiV1GetTopTalkerEpGet.bind(null, {
      app_service_id: id,
      start_time: DateTime.now().minus(timeRange).toISO(),
      end_time: DateTime.now().toISO(),
    }),
    { enabled: true, cacheTime: 0 },
  );

  const handleTimeChange = (e: React.MouseEvent<HTMLElement>, val: DurationLike) => {
    if (val) setTimeRange(val);
  };
  const handleRefreshClick = () => {
    refetch();
    toast.success('Refreshed chart data.');
  };

  useEffect(() => {
    refetch();
  }, [timeRange, refetch]);

  if (isLoading || isRefetching) {
    return <Loading />;
  }

  if (id === undefined || !data || data?.data.length === 0 || !Array.isArray(data?.data)) {
    return <NoData />;
  }

  return (
    <Box>
      <TimeRange
        timeValues={TIME_BUTTONS}
        selectedTime={timeRange}
        onTimeChange={handleTimeChange}
        onRefresh={handleRefreshClick}
      />
      <Card elevation={0}>
        <CardContent>
          <HorizontalBarChart loading={false} data={data.data} />
        </CardContent>
      </Card>
    </Box>
    // <DataTableGrid
    //   rows={
    //     data?.data.map((item) => {
    //       return {
    //         ...item,
    //         id: item.epid,
    //       };
    //     }) || []
    //   }
    //   columns={columns}
    //   columnVisibilityModel={columnVisible}
    // />
  );
};
